var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('google-pixel'),_c('content-container',[_c('account-content-heading'),_c('email-not-verified-warning'),_c('app-content')],1),_c('router-view',{staticClass:"account-actions",attrs:{"name":"actions"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }